export default __webpack_public_path__ + "static/media/about-bcg.3e4664c6.jpeg";